import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    paper: {
        margin: "auto",
        padding: theme.spacing(2),
    },
    container: {
        display: "flex",
        gap: "10px",
        flexWrap: "nowrap",
    },
    autocompleteOption: {
        display: "flex",
        flexDirection: "column",
        padding: 5,
        width: "100%",
    },
    autocompleteOptionUserName: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    },
    smallInfo: {
        fontSize: "smaller",
        color: "silver",
    },
    guestSmallInfo: {
        fontSize: "smaller",
        color: "#8d8d8d",
    },
    externalEmailChip: {
        marginLeft: 0,
        marginRight: 5,
        marginBottom: 5,
    },
    isGoingIcon: {
        width: 16,
        height: 16,
        marginLeft: 10,
        verticalAlign: "center",
    },
    displayFlex: {
        display: "flex",
    },
    readOnlyGuest: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        minHeight: 30,
        marginBottom: 5,
        padding: 7,
    },
    flexAlignItemsCenter: {
        display: "flex",
        alignItems: "center",
    },
    buttons: {
        display: "flex",
        flexDirection: "row-reverse",
    },
    button: {
        width: 32,
        height: 32,
    },
    goingNote: {
        display: "flex",
        flexDirection: "column",
        borderTop: "1px solid silver",
        marginTop: 20,
    },
    goingActions: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
}));

export default useStyles;
